// src/lib/query-client.ts
//
// QueryClient do TanStack Query. Garantia do education: o retry é decidido pela
// flag `retryable` do ApiError (não um retry cego). Cache fresco por 2 minutos; sem
// refetch no foco (evita rajadas ao alt-tab).
import { QueryClient } from "@tanstack/react-query";
import { ApiError, sessionQueryKey } from "@/api";

export const SESSION_STALE_TIME_MS = 2 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        error instanceof ApiError ? error.retryable && failureCount < 2 : failureCount < 1,
    },
    mutations: { retry: false },
  },
});

// A política explícita da sessão vale para todos os hooks que compartilham a
// mesma chave, independentemente de mudanças futuras no padrão geral.
queryClient.setQueryDefaults(sessionQueryKey, { staleTime: SESSION_STALE_TIME_MS });
